import styles from './style.module.css';
import { useState, useEffect } from 'react';
import api from '../../api';
import { Form, Input, Button } from '../index';

const RegistrationLiteForm = () => {
    const [schools, setSchools] = useState([])
    const [counter, setCounter] = useState(0)

    const [schoolName, setSchoolName] = useState('')
    const [fio, setFio] = useState('')
    const [region, setRegion] = useState('-')
    const [jobPlace, setJobPlace] = useState('-')
    const [job, setJob] = useState('-')
    const [phone, setPhone] = useState('-')
    const [email, setEmail] = useState('-')



    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        api.getConferences()
            .then((data) => {
                setSchools(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    useEffect(() => {
        api.getCounter()
            .then((data) => {
                setCounter(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        <div className={styles.conference_section__row}>
            {schools.results?.map((conference, index) => {
                return (
                    <>
                        <h3>{conference.name}</h3>
                        <>
                            <h4>Форма регистрации на конференцию</h4>
                            <Form
                                className={styles.form}
                                onSubmit={e => {
                                    e.preventDefault()
                                    const data = {
                                        school_name: schoolName,
                                        fio: fio,
                                        region: region,
                                        job_place: jobPlace,
                                        job: job,
                                        phone: phone,
                                        email: email
                                    }
                                    setSubmitting(true)
                                    setSchoolName("")
                                    setFio("")
                                    setRegion("-")
                                    setJobPlace("-")
                                    setJob("-")
                                    setPhone("-")
                                    setEmail("-")
                                    api
                                        .registrationConferenceLite(data)
                                }}
                            >

                                <Input
                                    required
                                    label='ФИО'
                                    name='fio'
                                    onChange={e => {
                                        const value = e.target.value
                                        setFio(value)
                                    }}
                                    value={fio}
                                />
                                {schools.results?.map((conference, index) => {
                                    return (
                                        <>
                                            <div className={styles.radioArea} key={index}>
                                                {conference.conference_school?.map((school, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <Input
                                                                required
                                                                label={school.name}
                                                                name="schoolName"
                                                                type="radio"
                                                                onChange={e => {
                                                                    const value = e.target.value
                                                                    setSchoolName(value)
                                                                }}
                                                                value={school.id}
                                                                id={school.id}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </>
                                    )
                                })}
                                <Button
                                    modifier='style_dark-blue'
                                    className={styles.button}
                                    type="submit"
                                >
                                    Зарегистрироваться
                                </Button>

                            </Form>
                        </>
                    </>
                )
            })
            }
        </div>
    )
};
export default RegistrationLiteForm;